<template>
  <v-autocomplete
    solo
    :clearable="clearable"
    :disabled="disabled"
    :label="label"
    :items="items"
    :item-text="textField"
    :item-value="valueField"
    :value="value"
    :no-data-text="emptyText"
    @input="updateValue"
    @blur="$emit('blur');"
    :error-messages="error"
    :multiple="multiple"
    :error="errorLocation || errorSelected"
    :id="selectId"
  >
    <template v-slot:prepend-inner>
      <i class="fal fa-angle-down" />
    </template>

    <!-- prepend-item -->
    <template v-if="multiple && !children" v-slot:prepend-item>
      <v-list-tile ripple @click.prevent="toggleAll">
        <v-list-tile-action>
          <v-checkbox :input-value="isSelectedAll">
            <template v-slot:append>
              <i class="fal fa-square" />
            </template>
            <template v-slot:prepend>
              <i class="fal fa-check-square" />
            </template>
          </v-checkbox>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Select All</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider class="mt-2"></v-divider>
    </template>

    <!-- prepend-item -->
    <template v-else-if="multiple && children && showSelectAll" v-slot:prepend-item>
      <v-list-tile ripple @click.prevent="toggleAllItem" class="select-children">
        <v-list-tile-action>
          <v-checkbox :input-value="isSelectedAll">
            <template v-slot:append>
              <i class="fal fa-square" />
            </template>
            <template v-slot:prepend>
              <i class="fal fa-check-square" />
            </template>
          </v-checkbox>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Select All</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider class="mt-2"></v-divider>
    </template>

    <!-- selection -->
    <template v-if="color" v-slot:selection="{item}">
      <v-chip
        class="selected-color-chip"
        small
        label
        :color="'#' + item.hex"
        text-color="transparent"
      >123456</v-chip>&nbsp;&nbsp;
      <span class="caption">{{ item[textField] }}</span>
    </template>
    <template v-else-if="multiple" v-slot:selection="{ item, index }">
      <span v-if="hideSelections && index === 0" class="label">{{ label }}</span>
      <template v-if="!hideSelections">
        <v-chip small v-if="index === 0">
          <span>{{ item[textField] }}</span>
        </v-chip>
        <span v-if="index === 1" class="caption">(+{{ value.length - 1 }} others)</span>
      </template>
    </template>

    <!-- item -->
    <template v-if="color" v-slot:item="{ item }">
      <v-chip small label :color="'#' + item.hex" text-color="transparent">123456</v-chip>&nbsp;&nbsp;
      <span class="caption">{{ item[textField] }}</span>
    </template>
    <template v-else-if="multiple && !children" v-slot:item="{ item }">
      <v-list-tile ripple @click.prevent="toggleSelected(item)">
        <v-list-tile-action>
          <v-checkbox :input-value="isSelected(item)">
            <template v-slot:append>
              <i class="fal fa-square" />
            </template>
            <template v-slot:prepend>
              <i class="fal fa-check-square" />
            </template>
          </v-checkbox>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ item[textField] }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </template>
    <!-- SELECTION SELECT MULTI AND CHILDREN

    <template v-else-if="multiple && children" v-slot:selection="{ item, index }">
        <span v-if="item.parent">{{ items.find(x => x.index == item.parent).name + '-' + item[textField] }}</span>
        <span v-else>{{ item[textField] }}</span>
    </template>-->
    <!-- ITEM SELECT MULTI AND CHILDREN-->
    <template v-else-if="multiple && children" v-slot:item="{ item, index }">
      <v-list-tile
        ripple
        @click.prevent="maxItem > 0 && value.length == maxItem ? function(){} : isToggleSelectedItem(item) && !item.selectAll ? toggleSelectedItem(item) : function(){}; item.selectAll ? selectAllItem(item) : function() {}; focusInput()"
        :class="{'ml-20': item.parent, 'ml-40': item.parent && checkLevelItem(item, 3), 'pl-10': isShowClassPL10(item)}"
        class="bb-1 select-children"
      >
        <v-list-tile-action
          v-if="!item.hasOwnProperty('showSelect') || ((!item.hasOwnProperty('showSelectCheckbox') || (item.hasOwnProperty('showSelectCheckbox') && item.showSelectCheckbox == true)) && showSelectCheckbox && item.hasOwnProperty('showSelect'))"
        >
          <v-checkbox
            :input-value="item.selectAll ? isSelectedAllItem(item) : isSelectedItem(item)"
            :disabled="(maxItem > 0 && value.length == maxItem) || !isToggleSelectedItem(item) "
          >
            <template v-slot:append>
              <i class="fal fa-square" />
            </template>
            <template v-slot:prepend>
              <i class="fal fa-check-square" />
            </template>
          </v-checkbox>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ item[textField] }}</v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action v-if="item.hasOwnProperty('showSelect')">
          <v-checkbox
            @click="$emit('showHiddenChildren', {index: item.index, parent: item.parent ? item.parent : 0}); checkItemShow(item)"
            :input-value="isShowSelectItem(item) || isShowSelectItemParent(item)"
          >
            <template v-slot:prepend>
              <i class="fal fa-minus"></i>
            </template>
            <template v-slot:append>
              <i class="fal fa-plus"></i>
            </template>
          </v-checkbox>
        </v-list-tile-action>
      </v-list-tile>
    </template>
  </v-autocomplete>
</template>

<script>
import Vue from "vue";

export default {
  name: "PosSelect",
  $_veeValidate: {
    name() {
      return this.name;
    },
    value() {
      return this.value;
    }
  },
  props: {
    label: { type: String, default: Vue.prototype.$gettext("Select ...") },
    name: { type: String, default: null },
    items: { type: Array, default: () => [] },
    textField: { type: String, default: "name" },
    valueField: { type: String, default: "id" },
    mixerGroup: { type: Boolean, default: false },
    emptyText: {
      type: String,
      default: Vue.prototype.$gettext("No record found ...")
    },
    value: null,
    error: { type: Array, default: () => [] },
    clearable: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    color: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    hideSelections: { type: Boolean, default: false },
    children: { type: Boolean, default: false },
    showSelectAll: { type: Boolean, default: true },
    maxItem: { type: Number, default: () => 0 },
    selectLocationStation: { type: Boolean, default: false },
    showSelectCheckbox: { type: Boolean, default: false },
    selectId: { type: String, default: "" },
    errorLocation: { type: Boolean, default: false },
    errorSelected: { type: Boolean, default: false }
  },
  data() {
    return {
      show: false,
      itemShow: -1,
      selectAll: [],
      selectedAll: false
    };
  },
  watch: {
    items: {
      deep: true,
      handler(newValue) {
        this.items = newValue;
      }
    }
  },
  computed: {
    isSelectedAll() {
      return this.multiple && this.value.length === this.items.length;
    }
  },
  methods: {
    isSelectedAllItem(item) {
      this.selectedAll =
        this.multiple &&
        ((this.selectAll.length &&
          this.selectAll.find(x => x.index == item.index)) ||
          this.value.length ==
            this.items.reduce((total, x) => {
              if (x.parent == item.parent) {
                return total + 1;
              }
              return total;
            }, -1));
      return this.selectedAll;
    },
    selectAllItem(item) {
      if (this.selectedAll) {
        this.value = [];
        this.selectAll = [];
      } else {
        this.selectAll.push(item);
        this.items.forEach(itemParent => {
          if (
            itemParent.parent == item.parent &&
            itemParent.index !== item.index
          ) {
            this.value.push(itemParent);
          }
        });
      }
      this.$emit("input", this.value);
    },
    focusInput() {
      document.getElementById(this.selectId).click();
    },
    isShowClassPL10(item) {
      return (
        item.hasOwnProperty("showSelectCheckbox") &&
        item.showSelectCheckbox == false &&
        item.hasOwnProperty("showSelect")
      );
    },
    isToggleSelectedItem(item) {
      return (
        !item.hasOwnProperty("showSelect") ||
        ((!item.hasOwnProperty("showSelectCheckbox") ||
          (item.hasOwnProperty("showSelectCheckbox") &&
            item.showSelectCheckbox == true)) &&
          this.checkLevel(3))
      );
    },
    checkLevelItem(item, level) {
      if (item.level == level) {
        return true;
      }
      return false;
    },
    checkLevel(level) {
      const find = this.items.find(item => item.level == level);
      if (!find) return true;
      return false;
    },
    checkItemShow(item) {
      if (item.level == 2 && item.index == this.itemShow) {
        this.itemShow = item.parent;
      } else if (item.index == this.itemShow) {
        this.itemShow = -1;
      } else {
        this.selectAll = [];
        this.itemShow = item.index;
      }
    },
    isShowSelectItemParent(item) {
      const find = this.items.find(i => i.index == this.itemShow);
      if (!find) return false;
      if (item.index == find.parent) return true;
      return false;
    },
    isShowSelectItem(item) {
      if (item.hasOwnProperty("showSelect")) {
        return item.index == this.itemShow;
      }
    },
    isSelected(item) {
      return this.value.includes(item[this.valueField]);
    },
    isSelectedItem(item) {
      return (
        (this.value.includes(item) && !this.selectLocationStation) ||
        (this.value.includes(item) && this.selectLocationStation && item.show)
      );
    },
    updateValue(value) {
      this.$emit("input", value);
      this.$emit("change", value);
    },
    toggleSelected(item) {
      const value = item[this.valueField];
      const exitedIndex = this.value.findIndex(v => v === value);
      if (exitedIndex >= 0) {
        this.value.splice(exitedIndex, 1);
      } else {
        this.value.push(value);
      }
      this.$emit("input", this.value);
    },
    toggleSelectedItem(item) {
      const value = item;
      const exitedIndex = this.value.findIndex(v => v.index === value.index);
      if (exitedIndex >= 0) {
        if (this.selectedAll) {
          this.selectAll = [];
        }
        if (item.hasOwnProperty("show") && !this.value[exitedIndex].show) {
          this.value[exitedIndex].show = true;
          this.value.forEach(locationStation => {
            if (locationStation.parent == value.parent) {
              let findIndex = -1;
              do {
                findIndex = this.value.findIndex(
                  x => x.parent === locationStation.parent
                );
                if (findIndex >= 0) {
                  this.value.splice(findIndex, 1);
                }
              } while (findIndex >= 0);
            }
            this.value.push(value);
          });

          return;
        }
        const hasParent = value.parent ? value.parent : 0;
        this.value.splice(exitedIndex, 1);
        if (hasParent > 0) {
          const findParent = this.value.find(
            parent => parent.index == hasParent
          );
          if (findParent && !findParent.hasOwnProperty("showSelect")) {
            var count = 1;
            this.value.forEach(ele => {
              if (ele.parent && ele.parent == value.parent) {
                count += 1;
              }
            });
            if (count == 1) {
              const exitedIndexParent = this.value.findIndex(
                v => v.index === value.parent
              );
              if (exitedIndexParent >= 0) {
                this.value.splice(exitedIndexParent, 1);
              }
            }
          }
        } else {
          let findIndex = -1;
          do {
            findIndex = this.value.findIndex(x => x.parent === value.index);
            if (findIndex >= 0) {
              this.value.splice(findIndex, 1);
            }
          } while (findIndex >= 0);
        }
      } else {
        if (this.selectLocationStation) value.show = true;
        this.value.push(value);
        if (value.parent) {
          let findParent = this.items.find(
            parent => parent.index == value.parent
          );
          if (findParent && !findParent.hasOwnProperty("showSelect")) {
            const exitedIndex = this.value.findIndex(
              v => v.index === value.parent
            );
            if (exitedIndex >= 0) return;
            this.items.forEach(itemParent => {
              if (itemParent.index == value.parent) {
                if (this.selectLocationStation) itemParent.show = true;
                this.value.push(itemParent);
                return;
              }
            });
          }
        } else {
          this.items.forEach(itemParent => {
            if (itemParent.parent == value.index) {
              if (this.selectLocationStation) itemParent.show = false;
              this.value.push(itemParent);
              return;
            }
          });
        }
      }
      this.$emit("input", this.value);
    },
    toggleAll() {
      if (this.value.length === this.items.length) {
        this.$emit("input", []);
      } else {
        this.$emit("input", this.getValues());
      }
    },
    toggleAllItem() {
      if (this.value.length === this.items.length) {
        this.$emit("input", []);
      } else {
        if (this.selectLocationStation) {
          this.items.forEach(itemParent => {
            itemParent.show = true;
          });
        }

        var value = Object.assign([], this.items);
        this.$emit("input", value);
      }
    },
    getValues() {
      const values = [];
      this.items.forEach(item => {
        values.push(item[this.valueField]);
      });
      return values;
    }
  }
};
</script>
<style>
.ml-20 {
  margin-left: 20px;
}
.ml-40 {
  margin-left: 40px;
}
.pl-10 {
  padding-left: 10px;
}
.bb-1 {
  border-bottom: 1px solid #ccc;
}
.select-children .v-list__tile {
  padding: 0 !important;
}
</style>

